import { gql } from '@apollo/client';

const PROJECT_OWNING_COLLABORATOR_QUERY = gql`
  query ProjectOwningCollaborator($id: ID!) {
    viewer {
      id
      company {
        id
      }
      project(id: $id) {
        id
        name
        owningCollaborator {
          __typename
          ... on CollaboratingCompany {
            id
            name
          }
        }
      }
    }
  }
`;

export default PROJECT_OWNING_COLLABORATOR_QUERY;
